import { pickBy, identity } from "lodash"

class ListDynamicChannelsRequest {

    constructor({
        sort, 
        page,
        search,
        perPage,
        communityId,
    }) {
        this.page = page
        this.sort = sort
        this.search = search
        this.perPage = perPage
        this.communityId = communityId
    }

    getPayload = () => {
        
        const payload = {
            "page": this.page,
            "sort": this.sort,
            "search": this.search,
            "per_page": this.perPage?.value || this.perPage,
            "community_id": this.communityId,
        }

        return pickBy(payload, identity)
    }
    
}

export default ListDynamicChannelsRequest
